export const MYDSPACE_ROUTE = '/mydspace';
